import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import type { FC } from "react";
import ImagePreview from "../components/imagePreview/ImagePreview";
import type { PublicPackageResponse } from "./publicPackagesApi";

type Day = PublicPackageResponse["days"][number];

interface Props {
  readonly day: Day;
  readonly dayDetailsType: "DESCRIPTION" | "PLAN";
}

const PackageDay: FC<Props> = ({ day, dayDetailsType }) => (
  <Grid container spacing={1}>
    <Grid size={3}>
      <Typography variant="body2">{day.dayNumber}. Dzień</Typography>
    </Grid>
    <Grid size={9} container spacing={1}>
      <Grid size={12}>
        <Typography variant="h6">{day.title}</Typography>
      </Grid>
      <Grid size={12}>
        <Typography>{dayDetailsType === "DESCRIPTION" ? day.details.description : day.details.plan}</Typography>
      </Grid>
      {day.image && (
        <Grid size={12}>
          <ImagePreview image={day.image} thumbnailSize="auto" />
        </Grid>
      )}
      {day.information && (
        <Grid size={12}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>Informacje praktyczne</AccordionSummary>
            <AccordionDetails>{day.information}</AccordionDetails>
          </Accordion>
        </Grid>
      )}
    </Grid>
  </Grid>
);

export default PackageDay;
